export function toLowerTraincase(word: string) {
	return word.toString().toLowerCase().split(" ").join("_")
}
